// import Icons
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'remixicon/fonts/remixicon.css';

// import Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';

// import customised components and styling files
import './App.css';

import React, { useEffect } from 'react';
import AppRouter from './routes/AppRouter';

function App() {

  return (

      <AppRouter />

  );
}

export default App;



